import { useState } from "react";
import { PhoneCall, Check } from "lucide-react";
import { TextField } from "../../components/Field";
import { Button } from "../../components/Button";
import { useSession } from "../../store/sessionStore";
import type { StepProps } from "../stepTypes";
import s from "../steps.module.css";

const PHONE_RE = /^[+0-9()\s-]{7,}$/;

/**
 * The "we'll call you" fallback used inside the no-slots state, so the journey
 * never dead-ends. Stores the number on the lead (status stays active) and
 * shows a friendly acknowledgement.
 */
export function CallbackPanel({ saveLead }: Pick<StepProps, "saveLead">) {
  const contact = useSession((st) => st.contact);
  const setContact = useSession((st) => st.setContact);
  const [phone, setPhone] = useState(contact.phone ?? "");
  const [done, setDone] = useState(false);
  const [touched, setTouched] = useState(false);

  const valid = PHONE_RE.test(phone.trim());

  if (done) {
    return (
      <div className={s.nextAvail} role="status">
        <Check size={16} /> Thanks — we&rsquo;ve got your number and the team will call
        you with the soonest opening.
      </div>
    );
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
      <TextField
        label="Your mobile number"
        type="tel"
        inputMode="tel"
        placeholder="07123 456789"
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
        error={touched && !valid ? "Enter a valid phone number" : null}
        icon={<PhoneCall size={18} />}
        autoComplete="tel"
      />
      <Button
        type="button"
        variant="secondary"
        onClick={() => {
          setTouched(true);
          if (!valid) return;
          setContact({ phone: phone.trim() });
          saveLead("datetime");
          setDone(true);
        }}
      >
        Request a callback
      </Button>
    </div>
  );
}
